// extracted by mini-css-extract-plugin
export default {"content":"styles_content__BCc1i","title":"styles_title__HObzM","image":"styles_image__uDsPc"};